var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLiveDataFeed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.993 12.36 3.08 8.54 2 9.38l6 4.667 6-4.667-1.087-.847-4.92 3.827zM8 10.667l4.907-3.82L14 6 8 1.333 2 6l1.087.847L8 10.667z"
})));
export default SvgLiveDataFeed;